import { List, SimpleGrid } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import EmailAttachment from "./Attachment";

const fragment = gql(/* GraphQL */ `
  fragment SelectedEmailAttachments on ReceivedEmailMessage {
    emailMessageId
    parsedReceivedEmailMessage {
      receivedEmailMessageId
      receivedEmailMessageAttachmentsList(
        filter: { isRelated: { distinctFrom: true } }
        orderBy: CREATED_AT_ASC
      ) {
        id
        ...EmailAttachment
      }
    }
  }
`);

type Props = {
  data: FragmentType<typeof fragment> | null | undefined;
};

export default function EmailAttachments({ data }: Props) {
  const rem = getFragmentData(fragment, data);

  const attachments =
    rem?.parsedReceivedEmailMessage?.receivedEmailMessageAttachmentsList;

  if (!attachments?.length) {
    return null;
  }

  return (
    <SimpleGrid
      as={List}
      templateColumns="repeat(auto-fill, minmax(14rem, 1fr))"
      gap={2}
      my={3}
    >
      {attachments.map((attachment) => (
        <EmailAttachment key={attachment.id} attachment={attachment} />
      ))}
    </SimpleGrid>
  );
}
